import { MediaImageStandard } from 'components/Contentful'
import { memo } from 'react'

const TrustPilotBadge = memo(({ trustPilot, className }) => {
  if (!trustPilot) return null
  return (
    <div className={className}>
      <MediaImageStandard
        content={trustPilot?.mediaContent}
        alt={trustPilot?.mediaAltText}
        fetchPriority="high"
        preload={true}
      />
    </div>
  )
})
TrustPilotBadge.displayName = 'TrustPilotBadge'

export { TrustPilotBadge }
